const BritishVirginIslandsSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_4152_111013)">
      <path
        d="M40 20C40 31.0456 31.0456 40 20 40C8.95437 40 0 31.0456 0 20C0 20.0048 20 0.0021875 20 0C31.0456 0 40 8.95437 40 20Z"
        fill="#0052B4"
      />
      <path
        d="M19.9468 19.9998H20.0003C20.0003 19.9818 20.0003 19.9643 20.0003 19.9463C19.9825 19.9642 19.9647 19.982 19.9468 19.9998Z"
        fill="#F0F0F0"
      />
      <path
        d="M20 10.4348C20 6.91563 20 4.60977 20 0H19.9966C8.95242 0.001875 0 8.95539 0 20H10.4348V14.1241L16.3106 20H19.9466C19.9644 19.9822 19.9822 19.9644 20.0001 19.9465C20.0001 18.5991 20.0001 17.3968 20.0001 16.3108L14.1241 10.4348H20Z"
        fill="#F0F0F0"
      />
      <path
        d="M10.1181 2.6084C6.99004 4.38957 4.38949 6.99004 2.6084 10.1181V19.9997H7.82582V7.82598V7.82582H19.9997C19.9997 6.18027 19.9997 4.61262 19.9997 2.6084H10.1181Z"
        fill="#D80027"
      />
      <path
        d="M28.6957 20L23.29 25.4057C24.3032 27.3597 26.3429 28.6956 28.6957 28.6956C31.0486 28.6956 33.0883 27.3597 34.1014 25.4057L28.6957 20Z"
        fill="#FFDA44"
      />
      <path
        d="M20.0003 17.5403L12.8944 10.4346H10.4351V10.4347L20.0001 19.9997H20.0003C20.0003 19.9997 20.0003 18.3039 20.0003 17.5403Z"
        fill="#D80027"
      />
      <path
        d="M22.6084 10.4346V19.9997V19.9998C22.6085 24.6591 28.6954 26.0868 28.6954 26.0868C28.6954 26.0868 34.7822 24.6591 34.7823 19.9998V19.9997V10.4346H22.6084Z"
        fill="#6DA544"
      />
      <path d="M27.3916 14.7832H30.0003V21.7397H27.3916V14.7832Z" fill="#F0F0F0" />
      <path
        d="M28.695 16.0873C29.4154 16.0873 29.9994 15.5033 29.9994 14.7829C29.9994 14.0625 29.4154 13.4785 28.695 13.4785C27.9746 13.4785 27.3906 14.0625 27.3906 14.7829C27.3906 15.5033 27.9746 16.0873 28.695 16.0873Z"
        fill="#A2001D"
      />
      <path d="M24.3477 12.1729H26.0868V13.912H24.3477V12.1729Z" fill="#FFDA44" />
      <path d="M24.3477 16.0869H26.0868V17.8261H24.3477V16.0869Z" fill="#FFDA44" />
      <path d="M24.3477 20H26.0868V21.7391H24.3477V20Z" fill="#FFDA44" />
      <path d="M31.3042 12.1729H33.0433V13.912H31.3042V12.1729Z" fill="#FFDA44" />
      <path d="M31.3042 16.0869H33.0433V17.8261H31.3042V16.0869Z" fill="#FFDA44" />
      <path d="M31.3042 20H33.0433V21.7391H31.3042V20Z" fill="#FFDA44" />
    </g>
    <defs>
      <clipPath id="clip0_4152_111013">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default BritishVirginIslandsSvg;
